import React from 'react';
import Section from '../../components/ui/Section';
import { motion } from 'framer-motion';

const AGB = () => (
  <div className="pt-32">
    <Section className="bg-dark">
      <div className="max-w-3xl mx-auto">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="text-gold tracking-widest uppercase text-sm mb-4">Legal</motion.p>
        <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-5xl font-serif text-cream mb-12">Allgemeine Geschäftsbedingungen</motion.h1>
        <div className="space-y-8 text-cream/65 font-light text-lg leading-relaxed">
          {[
            { title: '§ 1 Geltungsbereich', body: 'Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge zwischen Jennifer Gräser (Coaching Female) und ihren Klientinnen über Coaching-Dienstleistungen, Online-Kurse und digitale Produkte.' },
            { title: '§ 2 Vertragsschluss', body: 'Ein Vertrag kommt durch die schriftliche Auftragsbestätigung oder durch die Annahme des Angebots per E-Mail zustande. Der Vertragsgegenstand ergibt sich aus dem jeweiligen Angebot.' },
            { title: '§ 3 Preise und Zahlungsbedingungen', body: 'Alle Preise verstehen sich in Euro inklusive der gesetzlichen Mehrwertsteuer. Zahlungen sind innerhalb von 14 Tagen nach Rechnungsstellung fällig, sofern nicht anders vereinbart.' },
            { title: '§ 4 Widerrufsrecht', body: 'Verbraucherinnen steht ein gesetzliches Widerrufsrecht zu. Das Widerrufsrecht erlischt bei digitalen Inhalten, wenn mit der Ausführung begonnen wurde und die Verbraucherin dem zugestimmt hat.' },
            { title: '§ 5 Haftungsbeschränkung', body: 'Coaching ist keine Therapie und ersetzt keine medizinische oder psychologische Behandlung. Die Haftung für Schäden ist auf Vorsatz und grobe Fahrlässigkeit beschränkt.' },
          ].map((item, i) => (
            <div key={i}>
              <h2 className="text-xl font-serif text-cream mb-3">{item.title}</h2>
              <p>{item.body}</p>
            </div>
          ))}
        </div>
      </div>
    </Section>
  </div>
);

export default AGB;